<ng-container *ngIf="isCxone && view === Views.Main">
    <sol-omnibar
        *ngIf="isCxone"
        [isFilterable]="false"
        [itemCountLabel]="getCombinedLabel()"
        [searchPlaceholderText]="getLocalizationString('Search_Award','Search award')"
        (searchQueryChange)="filter.searchTerm = $event"
        [searchQuery]="filter.searchTerm"
    ></sol-omnibar>
    <div class="p-3 d-flex justify-content-between awards-buttons">
        <sol-dropdown
            [options]="cxoneSearchFolders.length > 0 ? cxoneSearchFolders : [defaultCategorySelection]"
            [placeholder]="getLocalizationString('Select_Category', 'Select Category')"
            (selectionChange)="filter.folder = $event.value"
            class="cxone-awards-dropdown"
            [selection]="filter.folder ? {
                value: filter.folder,
                name: filter.folder
            } : defaultCategorySelection"
        ></sol-dropdown>
        <div class="d-flex award-action-buttons">
            <sol-button
            variant="basic"
            size="large"
            (click)="openAwardHistoryModal()">
            <span runat="server" id="btnAwardHistory" cvLocalizedText langSection="Manual_Awards" 
                    langKey="Awards_History">Award History</span>
            </sol-button>
            <sol-button
            variant="primary"
            size="large"
            [disabled]="!hasPermissionAwards('CREATE')"
            (click)="hasPermissionAwards('CREATE') ? addManualAward() : ''">
            <span runat="server" id="btnNewAward" cvLocalizedText langSection="Manual_Awards" 
                    langKey="New_Award">New Award</span>
            </sol-button>
        </div>
    </div>
</ng-container>
<div [ngClass]="{'container p-4': !isCxone, 'overflow-auto cxone-tab-landing': isCxone, 'cxone-awards-container': isCxone && view === Views.Main}">
    <ng-container *ngIf="view === Views.Main">
        <div class="d-flex" *ngIf="!isCxone">
            <button type="button" class="btn btn-primary btn-icon" (click)="addManualAward()">
                <svg>
                    <use xlink:href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use>
                </svg>
                <span runat="server" id="btnNewAward" cvLocalizedText langSection="Manual_Awards"
                    langKey="New_Award">New Award</span>
            </button>
            <div class="maViewHistoryContainer ml-auto pt-1" (click)="loadModal()">
                <div class="maViewHistoryCalendarIcon align-text-bottom">
                </div>
                <div class="maViewHistoryText">
                    <span runat="server" cvLocalizedText langSection="Challenges"
                    langKey="View_History">View History</span>
                </div>
            </div>
            <div class="search-box live-search ml-3 w-25">
                <input type="search" class="form-control form-control-lg form-control-gray" placeholder="Search"
                    runat="server" cvLocalizedPlaceholder langSection="Common" langKey="Search"
                    [(ngModel)]="filter.searchTerm" />
                <span class="clear-input" *ngIf="filter.searchTerm.length > 0" (click)="filter.searchTerm = ''"></span>
            </div>
            <select class="form-control form-control-lg form-control-gray ml-4 w-25" [(ngModel)]="filter.folder"
                ngDefaultControl>
                <option class="d-none"></option>
                <option *ngFor="let folder of searchfolders" [value]="folder">{{ folder }}</option>
            </select>
        </div>
        <div *ngIf="isCxone && !showEmptyState && !filter.searchTerm" class="cxone-empty-state mt-0">
            <svg class="cxoneFavoriteState mb-2" style="width: 240px !important;">
                <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
            </svg>
            <p class="cxone-empty-text" cvLocalizedText langSection="Admin" langKey="Awards_Empty">No awards created yet</p>
        </div>

        <div *ngIf="isCxone && !showEmptyState && filter.searchTerm" class="cxone-empty-state mt-0">
            <svg class="cxoneFavoriteState mb-2" style="width: 240px !important;">
                <use href="../App_Themes/CXone/icons/no-results-big.svg#no-results-big"></use>
            </svg>
            <p class="cxone-empty-text" cvLocalizedText langSection="Manual_Awards" langKey="No_Results_Found">No results found</p>
        </div>
    
        <div class="d-flex position-absolute w-100 mt-2" [ngClass]="{'cxone-game-loading': isCxone}" style="height: 650px" *ngIf="loading">
            <cv-loader [loaderType]="isCxone ? 'cxone' : 'auto'" [size]="'large'" [overlay]="false"></cv-loader>
        </div>

        <div *ngFor="let folder of manualAwards.filter(filterFolders)" class="d-flex flex-column ml-3 my-3" [ngClass]="isCxone ? 'px-4': ''">
            <div class="d-flex flex-row align-items-center cursor-pointer" (click)="displayFolderContent(folder.Key)">
                <svg class="icon-16 fill-valyrianSteel">
                    <use [attr.href]="'../App_Themes/clearview-default/icons/utility/folder.svg#folder'"></use>
                </svg>
                <div class="glFolderTitle ml-2" title="{{folder.Key}}">
                    {{folder.Key}}
                    <svg class="icon-16 fill-valyrianSteel glGameFolder"
                        [ngStyle]="{'transform': maf.awardsFolderStates[folder.Key] ? 'rotate(90deg)' : 'rotate(0)'}">
                        <use [attr.href]="'../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right'">
                        </use>
                    </svg>
                </div>
            </div>
            <div *ngIf="maf.awardsFolderStates[folder.Key]" class="row pt-3 pl-2 pr-2"
                [ngClass]="{'mt-2': folder.Games != null && folder.Games.length > 0 ? 'mt-2' : '', 'pl-5': !isCxone, 'pl-2 pr-2': isCxone}">
                <div *ngFor="let item of folder.Value" [attr.rule-id]="item.RuleID" class="col-12 col-lg-6"
                    [ngClass]="{'d-none': !filterManualAwards(item), 'col-xxl-4 mb-3 cxone-card-height': isCxone}">
                    <ng-container *ngIf="filterManualAwards(item)">
                        <div class="maItem anim p-4 d-flex mb-4" [ngClass]="{'h-100 cxone-card': isCxone}">
                            <div class="maItemOptions" (click)="showOptionsMenu(item);"></div>
                            <div class="maItemLeft" [ngClass]="{'cxone-badge-image-container': isCxone}">
                                <div class="maItemImg">
                                    <img [src]="'../Admin/ImageResizer.aspx?imgid=' + item.BadgeID + '&w=100&h=100'" />
                                </div>
                                <div class="btn-text text-center cursor-pointer mt-4" (click)="showAwardedPopup(item)" *ngIf="!isCxone">
                                    <div>{{item.AwardedCount != null ? item.AwardedCount : 0}}</div>
                                    <div runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Awarded">
                                        Awarded</div>
                                </div>
                            </div>
                            <div class="maItemRight" [ngClass]="{'cxone-information-container': isCxone}">
                                <div *ngIf="!isCxone; else cxoneTitle" class="font-size-16 font-weight-bold color-no2Pencil award-name" title="{{item.Name}}">
                                    {{item.Name}}</div>
                                    <ng-template #cxoneTitle>
                                        <span #cxoneTitle class="font-size-16 font-weight-bold color-no2Pencil award-name text-ellipsis mr-2" [ngbPopover]="tooltipText" (mouseenter)="checkTextTruncation(item.Name, cxoneTitle)" (mouseleave)="clearTooltipText()" triggers="mouseenter:mouseleave" container="body" popoverClass="cxone-award-tooltip">
                                            {{item.Name}}
                                        </span>
                                    </ng-template>
                                <div class="maItemDetailsLine">
                                    <div class="maItemDetailsCreated" [ngClass]="{'award-date': isCxone}">
                                        <span class="maItemCreatedIcon mr-2" *ngIf="!isCxone"></span>
                                        <svg class="icon-16 calendar-icon mr-2" *ngIf="isCxone">
                                            <use href="../../../App_Themes/CXone/icons/calendar.svg#calendar"></use>
                                        </svg>
                                        <span class="maItemCreatedText" runat="server" cvLocalizedText
                                            langSection="Manual_Awards" langKey="Created">Created on</span>
                                        <span class="maItemCreatedText ml-1">{{item.DateCreatedForView}}</span>
                                    </div>
                                    <!-- <div *ngIf="false" class="maItemSeeDetailsLink" (click)="detailsShow(item);">See
                                        Details</div> -->
                                </div>
                                <div *ngIf="!isCxone; else cxoneDescription" class="maItemDesc" title="{{item.Description}}">{{item.Description}}</div>
                                <ng-template #cxoneDescription>
                                    <span #description class="cxone-description" [ngbPopover]="tooltipText" (mouseenter)="checkTextTruncation(item.Description, description)" (mouseleave)="clearTooltipText()" triggers="mouseenter:mouseleave" container="body" popoverClass="cxone-award-tooltip">{{item.Description}}</span>
                                </ng-template>
                                <div class="maItemFooter" [ngClass]="{'mt-auto': isCxone}">
                                    <div>
                                        <span *ngIf="!isCxone; else cxoneIcon" class="maItemPayoutCoinIcon"></span>
                                        <ng-template #cxoneIcon>
                                            <svg class="icon-16 mb-1">
                                                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                                            </svg>
                                        </ng-template>
                                        <span *ngIf="!isCxone; else cxonePrice" class="maItemPayoutCoinVal">{{item.Coins}}</span>
                                        <ng-template #cxonePrice>
                                            <span class="maItemPayoutCoinVal">{{item.Coins | cvNumberLocalize}}</span>
                                        </ng-template>
                                    </div>
                                    <div *ngIf="!isCxone">
                                        <span class="d-inline-block align-text-bottom">
                                            <svg class="fill-dimetapp" width="20px" height="20px">
                                                <use [attr.href]="'../App_Themes/clearview-default/icons/utility/xp.svg#xp'">
                                                </use>
                                            </svg>
                                        </span>
                                        <span class="maItemPayoutCoinVal">{{item.XP}}</span>
                                    </div>
                                    <div *ngIf="!isCxone" class="btn btn-primary" (click)="openAwardPopup(item)" runat="server" cvLocalizedText
                                         langSection="Manual_Awards" langKey="Give">Give</div>
                                    <sol-button *ngIf="isCxone" [disabled]="!hasPermissionAwards('READ')" (click)="hasPermissionAwards('READ') ? openAwardPopup(item) : ''"
                                        variant="primary" size="large" class="sol-buttons-design">
                                        <span cvLocalizedText langSection="Manual_Awards" langKey="Give">Give</span>
                                    </sol-button>
                                </div>
                            </div>
                            <!-- Options Menu -->
                            <ng-container *ngIf="item.showOptions">
                                <cv-awards-card-menu [visible]="item.showOptions" [item]="item"
                                    (onChangeView)="changeView($event)" [removeAwardFromFrontend]="removeAwardFromFrontend"
                                    [resetToOriginal]="ResetToOriginal"
                                    [isCopyChange]="handleIsCopyChange"
                                    [isCopy]="isCopy"
                                    [_old]="_old"
                                    (updateOldValue)="updateOldValue($event)"
                                    [isCxOne]="isCxone"
                                    >
                                </cv-awards-card-menu>
                            </ng-container>        
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <cv-give-award-popup
          [awardToolVisible]="awardToolVisible"
          (closeAwardPopup)="closeAwardPopup()"
          [manualAward]="manualAward"
        ></cv-give-award-popup>
        <cv-awards-history-list 
            [isVisible]="isVisible"
            (closeAwardHistoryPopup)="closeAwardHistoryPopup()"
        ></cv-awards-history-list>
        <cv-awarded-popup *ngIf="awardedIsVisible && selectedAward && item" 
        [selectedAward]="selectedAward"
        [awardedIsVisible]="awardedIsVisible"
        (hideAwardedPopup)="hideAwardedPopup()"
        (reference)="onReference($event)"
        [item]="item"
        [ngClass]="{ 'lower-z-index': awardToolVisible }"
        ></cv-awarded-popup>
    </ng-container>
    <ng-container *ngIf="view === Views.AddEdit">
        <ng-container *ngIf="folders && item">
            <cv-awards-add-edit [ngClass]="{'position-relative': !isCxone}" [item]="item" [folders]="folders" [badgeIDs]="badgeIDs" [coinValue]="coinValue"
                 [resetToOriginal]="ResetToOriginal" (onChangeView)="changeView($event)"
                [manualAwards]="manualAwards"
                [_old]="_old"
                (updateOldValue)="updateOldValue($event)"
                [isCopy]="isCopy"
                (onSaveNewFolder)="onNewFolder($event)"
                >
            </cv-awards-add-edit>
        </ng-container>
    </ng-container>


</div>
